
let _ = require('../_.js');
let $ = jQuery;

_.Notification_Standard_Completed_Winner = class Notification_Standard_Completed_Winner {

    notification = null;

    constructor(notification) {
        this.notification = notification;
    }

    static _denied_modal_init = false;
    static _denied_modal_action = null;

    $modal() {
        return $("#ac-modal-standard-completed-winner-modal");
    }

    // auction_round_id, bid_id, is_tie_bid = false) {
    async on_show() {
        let that = this;

        let meta;
        let bid_id = null;
        let round_id = null;
        let item_id = null;

        // try {
        meta = JSON.parse(this.notification.meta)
        bid_id = meta.bid_id;
        round_id = meta.round_id;
        item_id = meta.item_id;
        // } catch (e) {
        // }

        if (!_.Notification_Standard_Completed_Winner.denied_modal_init) {
            _.Notification_Standard_Completed_Winner.denied_modal_init = true;
            $("#ac-modal-standard-completed-winner-close").click(function (e) {
                e.preventDefault();
                _.Modal.close_unhidable();
            });
        }

        // The modal itself.
        // Call resolve when we are done here.
        await new Promise(function (resolve, reject) {
            (async function () {
                let item = await App_Models_AuctionItem.fetch_private(item_id);
                let round = await App_Models_AuctionRound.fetch_private(round_id);
                let auction = await round.auction.fetch_private();

                if (!round || !item || !auction) {
                    await _.Modal.alert("You have won auction item ID " + item + ", but there was an error loading item data.  Please refresh the page.\n\n" +
                        "If you are still experiencing issues, contact LandProz support.");
                    return;
                }

                $("#ac-modal-standard-completed-winner-tract-number").text(item.lot_number);

                let $sold_details = $("#ac-modal-standard-completed-winner-tract-details").empty();

                let high_bid = round.current_bid_amount;

                let $item = $("<div></div>");
                $item.attr('style', 'margin-bottom: 15px; margin-top: 5px;');
                let $item_header = $("<div></div>").text(item.title).style('font-weight', 'bold');
                $item.append($item_header);

                if (item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
                    let $item_calc = $("<div></div>").attr('style', 'padding-bottom: 1px; border-bottom: 1px solid #000; margin-bottom: 3px;');
                    let $high_bid = $("<span></span>").text(_.currency(high_bid)).style('font-weight', 'bold');
                    let $acres_text = $("<span></span>").text(" x " + item.acres + _.property_noun_unit_plural_plusminus() + " =");
                    $item_calc.append($high_bid);
                    $item_calc.append($acres_text);
                    $item.append($item_calc);
                } else {
                    $item.append($("<div>Flat Price</div>"));
                }

                let $total_calc = $("<div></div>").text(_.currency(item.sale_price)).style('font-weight', 'bold');
                $item.append($total_calc);

                $sold_details.append($item);

                let subtotal = item.sale_price;

                let $total_container = $("<div></div>").attr('style', 'display: table; margin: auto;');

                let $total_label = $("<div></div>").text("TOTAL").attr('style', 'font-size: 24px; font-weight: bold;');
                $total_container.append($total_label);

                let $subtotal_line = $("<div></div>").text(_.currency(subtotal) + " subtotal").style('font-style', 'italic');
                $total_container.append($subtotal_line);

                let $total_fees_representation = $("<div></div>").attr('style', 'padding-bottom: 1px; border-bottom: 1px solid #000; margin-bottom: 3px;');
                $total_fees_representation.text("+ " + _.percentage(auction.total_fees) + " fees =").style('font-style', 'italic');
                $total_container.append($total_fees_representation);

                let $final_total_line = $("<div></div>")
                    .text(_.currency(subtotal * (1 + (auction.total_fees / 100))))
                    .attr('style', 'font-weight: bold; font-size: 20px; margin-bottom: 23px;');
                $total_container.append($final_total_line);

                $sold_details.append($total_container);

                let deferred = $.Deferred();

                that.$modal().data('deferred', deferred);

                that.$modal().modal_show();

                // Wait for the modal to close.
                await deferred.promise();

                resolve();
            })();
        });

        await _.Lib_Notifications.dismiss_notification(this.notification.id);
    }

    async on_update() {
        // Update related data about the notification in real time.
    }

    async on_hide() {
    }
}